export const quizQuestions = [
  {
    id: "sf_001",
    category: "surah_facts",
    difficulty: "easy",
    question: "Which surah is known as The Opening?",
    options: ["Al-Baqarah", "Al-Fatihah", "Al-Ikhlas", "Yasin"],
    answer: "Al-Fatihah",
    explanation:
      "Al-Fatihah is the opening chapter of the Quran and is recited in every salah.",
    reference: "Surah Al-Fatihah",
  },
  {
    id: "sf_002",
    category: "surah_facts",
    difficulty: "easy",
    question: "How many ayahs are in Surah Al-Ikhlas?",
    options: ["3", "4", "5", "6"],
    answer: "4",
    explanation: "Surah Al-Ikhlas contains 4 ayahs.",
    reference: "Surah Al-Ikhlas",
  },
  {
    id: "sf_003",
    category: "surah_facts",
    difficulty: "easy",
    question: "Which surah contains Ayat al-Kursi?",
    options: ["Al-Fatihah", "Al-Baqarah", "Yasin", "Al-Mulk"],
    answer: "Al-Baqarah",
    explanation: "Ayat al-Kursi is verse 255 of Surah Al-Baqarah.",
    reference: "Surah Al-Baqarah 2:255",
  },
  {
    id: "sf_004",
    category: "surah_facts",
    difficulty: "easy",
    question: "Surah An-Nas mainly teaches us to seek protection from what?",
    options: ["Poverty", "Enemies only", "Whispers of evil", "Travel danger"],
    answer: "Whispers of evil",
    explanation:
      "Surah An-Nas teaches us to seek refuge in Allah from the whisperer.",
    reference: "Surah An-Nas",
  },
  {
    id: "qp_001",
    category: "quran_phrases",
    difficulty: "easy",
    question: "What does Ar-Rahman mean?",
    options: ["The King", "The Most Merciful", "The Creator", "The Judge"],
    answer: "The Most Merciful",
    explanation:
      "Ar-Rahman is one of the beautiful names of Allah and points to His vast mercy.",
    reference: "Common Quranic vocabulary",
  },
  {
    id: "qp_002",
    category: "quran_phrases",
    difficulty: "easy",
    question: "What does Al-Hamdulillah mean?",
    options: [
      "Allah is Greatest",
      "Peace be upon you",
      "All praise is for Allah",
      "I seek forgiveness",
    ],
    answer: "All praise is for Allah",
    explanation:
      "Al-Hamdulillah is an expression of gratitude and praise to Allah.",
    reference: "Surah Al-Fatihah 1:2",
  },
  {
    id: "qp_003",
    category: "quran_phrases",
    difficulty: "easy",
    question: "What does Ihdina الصراط المستقيم ask Allah for?",
    options: [
      "Wealth",
      "Victory",
      "Guidance to the straight path",
      "Long life",
    ],
    answer: "Guidance to the straight path",
    explanation:
      "This phrase from Surah Al-Fatihah is a dua asking Allah for guidance.",
    reference: "Surah Al-Fatihah 1:6",
  },
  {
    id: "qp_004",
    category: "quran_phrases",
    difficulty: "easy",
    question: "What does Rabb usually refer to in the Quran?",
    options: ["Prophet", "Lord", "Angel", "Believer"],
    answer: "Lord",
    explanation: "Rabb refers to Allah as Lord, Sustainer, and Nurturer.",
    reference: "Common Quranic vocabulary",
  },
  {
    id: "hc_001",
    category: "hadith_connection",
    difficulty: "easy",
    question:
      "The hadith 'The best of you are those who learn the Quran and teach it' encourages which habit?",
    options: [
      "Arguing over details",
      "Learning and sharing the Quran",
      "Reading only in Ramadan",
      "Memorizing without understanding",
    ],
    answer: "Learning and sharing the Quran",
    explanation:
      "This hadith encourages a living relationship with the Quran through learning and teaching.",
    reference: "Sahih al-Bukhari",
  },
  {
    id: "hc_002",
    category: "hadith_connection",
    difficulty: "easy",
    question:
      "A hadith teaches that Allah looks at the heart and deeds. Which Quran value does that most closely reinforce?",
    options: ["Sincerity", "Speed", "Debate", "Status"],
    answer: "Sincerity",
    explanation:
      "Both the Quran and Sunnah repeatedly emphasize sincerity in worship and action.",
    reference: "Sahih Muslim",
  },
  {
    id: "hc_003",
    category: "hadith_connection",
    difficulty: "easy",
    question:
      "Which habit best matches the prophetic encouragement to remember Allah often?",
    options: [
      "Only remembering Allah in difficulty",
      "Daily dhikr and Quran reflection",
      "Reading without attention",
      "Competing for praise",
    ],
    answer: "Daily dhikr and Quran reflection",
    explanation:
      "The prophetic path builds consistency in remembrance, not only occasional bursts.",
    reference: "General prophetic guidance on dhikr",
  },
  {
    id: "hc_004",
    category: "hadith_connection",
    difficulty: "easy",
    question:
      "The Prophet ﷺ taught that deeds most loved by Allah are those done consistently. What does that suggest for Quran habits?",
    options: [
      "Read once a year intensely",
      "Small daily Quran practice",
      "Only listen passively",
      "Delay until Ramadan",
    ],
    answer: "Small daily Quran practice",
    explanation:
      "Consistency is more transformative than rare bursts of effort.",
    reference: "Sahih al-Bukhari / Sahih Muslim meaning",
  },
];
